import { Component } from '@angular/core';

@Component({
    selector: 'app-in-develop',
    templateUrl: './in-develop.component.html',
    styleUrls: ['./in-develop.component.scss'],
    standalone: false
})
export class InDevelopComponent {

}
